import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import * as Sentry from '@sentry/react';
import { calculationsUISlice } from '@ui/features/Calculations/slices';
import { chatSlice } from '@ui/features/Chat/slices';
import tabsReducer from '@ui/features/Chat/slices/tabsSlice';
import { dataCurationSlice } from '@ui/features/DataCuration/slices';
import cpgRagReducer from '@ui/features/CpgRag/slices/cpgRagSlice';
import dbExplorerReducer from '@ui/features/DbExplorer/dbExplorerSlice';
import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import userReducer from '../store/slices/userSlice';
import { api } from './api';
import { imagingViewerReducer } from '../pages/DeIdentification/slices';
import terminologySearchReducer from '@ui/features/TerminologyServer/slices/terminologySearchSlice';
import { terminologyApi } from '@ui/features/TerminologyServer/services/api';

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

export const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        [terminologyApi.reducerPath]: terminologyApi.reducer,
        user: userReducer,
        chatSlice,
        tabs: tabsReducer,
        calculationsUI: calculationsUISlice,
        dataCuration: dataCurationSlice,
        cpgRag: cpgRagReducer,
        dbExplorer: dbExplorerReducer,
        imagingViewer: imagingViewerReducer,
        terminologySearch: terminologySearchReducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(api.middleware, terminologyApi.middleware),
    enhancers: getDefaultEnhancers => getDefaultEnhancers().concat(sentryReduxEnhancer),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;

setupListeners(store.dispatch);
